import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function SetaRolar() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const aoRolar = () => {
      setVisivel(window.scrollY > 100);
    };

    window.addEventListener("scroll", aoRolar);
    return () => window.removeEventListener("scroll", aoRolar);
  }, []);

  const rolarParaTopo = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    visivel && (
      <button
        onClick={rolarParaTopo}
        aria-label="Voltar ao topo"
        className="fixed bottom-6 right-1 md:right-6 z-50 bg-[#C9AA7B] text-white p-3 rounded-full shadow-lg hover:scale-110 transition-all duration-300"
      >
        <FaArrowUp className="text-lg" />
      </button>
    )
  );
}
